import React, { useState } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { Box, Card, Typography } from "@mui/material";
import moment from "moment";
import { DEFAULT_DATE_FORMAT } from "config";
import ActionTrackerListPopUp from "./ActionTrackerListPopUp";
import { getPreviousSunday, getNextSunday, formatDate } from "helpers/actionTrackerOptions";


const AgeingAnalysisChart = ({ data, columns }) => {

    const [isViewTracker, setIsViewTracker] = useState(false);
    const [rowData, setRowData] = useState(null);

    const pieData = data?.map(item => ({
        name: item.name,
        y: item.y
    })) || [];

    const hasData = pieData.length > 0 && pieData.some(p => p.y && p.y !== 0);

    const options = {
        colors: ["#2caffe", "#238ccb", "#1a6998", "#124666"],
        chart: {
            type: "pie",
            height: "70%",
            margin: 0
        },
        title: {
            text: "",
            style: {
                color: "#7E7E7E",
                fontWeight: '500',
                fontFamily: "Outfit"
            }
        },
        tooltip: {
            pointFormat: "{series.name}: <b>{point.y}</b>",
            style: {
                color: "#7E7E7E",
                fontWeight: '500',
                fontFamily: "Outfit"
            }
        },
        accessibility: {
            point: {
                valueSuffix: "%"
            }
        },
        credits: { enabled: false },
        plotOptions: {
            pie: {
                allowPointSelect: false,
                cursor: "pointer",
                size: '70%',
                borderWidth: 0,
                borderRadius: 0,
                innerSize: "60%",
                point: {
                    events: {
                        click: function () {
                            // console.log("Clicked", this);

                            onBarClick(this);
                            // alert(
                            //     `Category: ${this?.name}\n` +
                            //     `Series: ${this?.series.name}\n` +
                            //     `Value: ${this?.y}`
                            // );
                        }
                    }
                },
                dataLabels: {
                    enabled: true,
                    distance: 0,
                    format: "<b>{point.name}</b>: {point.y}",
                    style: {
                        color: "#7E7E7E",
                        fontWeight: '500',
                        fontFamily: "Outfit",
                        textOutline: 'none',
                        textShadow: 'none',
                        fontSize: '14px'
                    }
                }
            }
        },
        series: [
            {
                name: "Open",
                colorByPoint: true,
                data: pieData
            }
        ]
    };

    const onBarClick = (point) => {
        setIsViewTracker((prev) => {
            const newState = !prev;
            setRowData(newState ? { Ageing: point?.name, Status: point?.series?.name, } : null);
            return newState;
        });
    }

    const handleClose = () => {
        setIsViewTracker(false)
        setRowData(null)
    }

    return (
        <>
            <Card
                elevation={0}
                sx={{
                    borderRadius: "3px",
                    border: "1px solid #E4E4E4",
                    width: '100%',
                    minHeight: { xs: 340, md: 340, xl: "auto" },
                    maxHeight: { xs: 340, md: 340, xl: "none" },
                    display: "flex",
                    flexDirection: "column",
                }}
            >
                <Box sx={{
                    width: '100%',
                    borderBottom: "1px solid #E4E4E4",
                    p: 1,
                    mb: 2,
                    display: 'flex',
                    justifyContent: 'space-between'
                }}>
                    <Box>
                        <Typography variant="subtitle1" sx={{
                            fontFamily: "Outfit, sans-serif",
                            fontWeight: 600,
                            fontSize: '20px',
                            letterSpacing: "0px",
                            mb: 0
                        }}>
                            Ageing Analysis of Open Items.
                        </Typography>
                        <Typography variant="subtitle1" sx={{
                            fontWeight: 500,
                            fontSize: '14px',
                            lineHeight: "140%",
                            color: "#7D7F81",
                            letterSpacing: "1%",
                            fontFamily: "Poppins, sans-serif",
                        }}>
                            Time-based categorization of unresolved action items
                        </Typography>

                    </Box>

                </Box>

                {/* 👇 Conditional content area */}
                {hasData ? (
                    <HighchartsReact highcharts={Highcharts} options={options} />
                ) : (
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            pb: 2,
                        }}
                    >
                        <Typography
                            sx={{
                                fontFamily: "Outfit, sans-serif",
                                fontSize: "16px",
                                fontWeight: 500,
                                color: "#9E9E9E",
                            }}
                        >
                            Data Not Available
                        </Typography>
                    </Box>
                )}
            </Card>
            {isViewTracker &&
                <ActionTrackerListPopUp open={isViewTracker} data={rowData} handleClose={handleClose} columns={columns} />
            }
        </>
    )

};

export default AgeingAnalysisChart;
